import React, { useState } from "react";
import { Offcanvas, OffcanvasHeader, OffcanvasBody, Nav, NavItem, NavLink, TabContent, TabPane, Card, CardBody, Button, Badge } from "reactstrap";
import classnames from "classnames";
import { getWorkoutTemplates } from "../../../../models/workout/mockWorkouts";

const WorkoutTemplateSidebar = ({ isOpen, toggle, selectedDate, onSelectTemplate }) => {
    const [activeTab, setActiveTab] = useState("0");

    // Recalcula templates para garantir que usem a data selecionada
    const templatesData = getWorkoutTemplates(selectedDate);

    const toggleTab = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    const calculateDistance = (blocks) => {
        let total = 0;
        blocks?.forEach(block => {
            block.sets?.forEach(set => {
                total += (Number(set.reps) || 0) * (Number(set.distance) || 0);
            });
        });
        return total;
    };

    return (
        <Offcanvas isOpen={isOpen} toggle={toggle} direction="end" style={{ width: "400px" }}>
            <OffcanvasHeader toggle={toggle} className="border-bottom pb-3">
                <div className="d-flex align-items-center gap-2">
                    <i className="mdi mdi-auto-fix fs-4 text-info"></i>
                    <div>
                        <h5 className="mb-0">Treinos Modelo</h5>
                        <small className="text-muted">Selecione um treino base para aplicar</small>
                    </div>
                </div>
            </OffcanvasHeader>
            <div className="bg-light px-2 pt-2 border-bottom">
                <Nav pills className="navtab-bg nav-justified" style={{ overflowX: "auto", flexWrap: "nowrap" }}>
                    {templatesData.map((categoryGroup, index) => (
                        <NavItem key={index}>
                            <NavLink
                                style={{ cursor: "pointer", whiteSpace: "nowrap", padding: "8px 12px", fontSize: "0.85rem" }}
                                className={classnames({ active: activeTab === index.toString() })}
                                onClick={() => toggleTab(index.toString())}
                            >
                                {categoryGroup.category}
                            </NavLink>
                        </NavItem>
                    ))}
                </Nav>
            </div>
            <OffcanvasBody className="p-3 bg-light-subtle">
                <TabContent activeTab={activeTab}>
                    {templatesData.map((categoryGroup, index) => (
                        <TabPane tabId={index.toString()} key={index}>
                            <div className="d-flex flex-column gap-3">
                                {categoryGroup.templates.map((template, tIndex) => {
                                    const totalDist = calculateDistance(template.blocks);
                                    return (
                                        <Card className="border-0 shadow-sm hover-shadow transition-all" key={tIndex}>
                                            <CardBody className="d-flex flex-column p-3">
                                                <h6 className="fw-bold mb-2 text-dark">{template.title}</h6>
                                                <p className="text-muted small mb-3 flex-grow-1" style={{ fontSize: "0.8rem" }}>
                                                    {template.description}
                                                </p>
                                                <div className="d-flex justify-content-between align-items-center mt-auto border-top pt-2">
                                                    <Badge color="primary" className="px-2 py-1">
                                                        {totalDist}m
                                                    </Badge>
                                                    <Button
                                                        color="info"
                                                        outline
                                                        size="sm"
                                                        onClick={() => {
                                                            onSelectTemplate(template);
                                                            toggle();
                                                        }}
                                                    >
                                                        <i className="mdi mdi-check"></i> Utilizar
                                                    </Button>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    );
                                })}
                            </div>
                        </TabPane>
                    ))}
                </TabContent>
            </OffcanvasBody>
        </Offcanvas>
    );
};

export default WorkoutTemplateSidebar;
